// Timing helpers for the live chat room client. Every delay that many viewers could hit at the
// same moment (a go-live crowd, an edge blip) is jittered so they do not re-collide.

// A random delay in [ms, ms + spread).
export function jitter(ms, spread = 0) {
  return ms + Math.random() * spread;
}

// base * 2^attempt capped at `cap`, with +/-25% jitter. attempt is zero-based.
export function expBackoff(attempt, { base = 1000, cap = 30000 } = {}) {
  const raw = Math.min(cap, base * 2 ** Math.max(0, attempt));
  return raw * 0.75 + Math.random() * raw * 0.5;
}

// Resolves after `ms`, or as soon as `signal` aborts - callers re-check their own aborted flag
// afterwards, so a disposed client never acts on a wait it outlived.
export function sleep(ms, signal) {
  return new Promise((resolve) => {
    if (signal && signal.aborted) {
      resolve();
      return;
    }

    const timer = window.setTimeout(done, ms);
    function done() {
      window.clearTimeout(timer);
      if (signal) signal.removeEventListener("abort", done);
      resolve();
    }
    if (signal) signal.addEventListener("abort", done);
  });
}
